import { _data, VehicleDetails } from './data.tyre.js';

var VehiclePanel = function () {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------

    var BindControls = function () {

    };

    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------

    return {
        InitializePanel: function () {
            BindControls();
        },
        SaveVehicleDetails: function () {
            let mileage = $('#vehicleDetailsSection #Mileage').val().replace(',', '');
            let reg = $('#vehicle-registration').text();
            let vehicleId = $('#VehicleID').val();
            let make = $('#vehicleDetailsSection #vehicle-make').text();
            let model = $('#vehicleDetailsSection #vehicle-description').text();
            let orderNumber = $('#CustomerOrderNumber').length
                ? $('#CustomerOrderNumber').val()
                : null;
            let mileageNotRequired = $('#mileageInput').is(':hidden');
            _data.vehicle.vehicleDetails = new VehicleDetails(mileage, reg, vehicleId, make, model, orderNumber, mileageNotRequired);            
        },
        VehicleRegistration: function () {
            return $('#vehicleDetailsSection #vehicle-registration').text();
        },
        VehicleMake: function () {
            return $('#vehicleDetailsSection #vehicle-make').text();
        },
        VehicleDescription: function () {
            return $('#vehicleDetailsSection #vehicle-description').text();
        }
    };
};

export let _vehiclePanel = new VehiclePanel();
